import { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import getGlobal from '../Queries/getGlobal';

//Components
import SectionTitle from '../SectionTitle';
import OrderCard from '../OrderCard';
import ItemOrder from './ItemOrder';
import TextInput from '../TextInput';
import Alert from '../Alert';

//Styles
import styles from './index.module.sass';

export default function MyDigitalOrders(props) {
  const now = new Date();
  const { device, setSessionMessage } = props;
  const { screenSize } = device;
  const { t } = useTranslation('digitalOrders');
  const tableItems = t('tableItems', { returnObjects: true });
  const [ordersDate, setOrdersDate] = useState(
    `${now.getFullYear()}-${('0' + (now.getMonth() + 1)).slice(-2)}`,
  );
  const [open, setOpen] = useState(false);
  const [alertText, setalertText] = useState('');
  const [data, setdata] = useState([]);

  function searchByDate() {
    const dateArray = ordersDate.split('-');
    if (dateArray.length === 2) {
      getPedidosCatalogo(dateArray[0], dateArray[1]);
    }
  }

  const getPedidosCatalogo = useCallback(
    async (axo = '', mes = '') => {
      const response = await getGlobal({
        tmbservice: 'getPedidosCatalogo',
        jsonBody: {
          idioma: window?.localStorage?.getItem('i18nextLng')?.includes('es') ? 0 : 1,
          axo,
          mes,
        },
      });
      const { message, pedido, typeMessage } = response;

      setSessionMessage(message);

      if (typeMessage === 'error' && message !== '498' && message !== '499') {
        setalertText(message);
        setOpen(true);
        return;
      } else {
        setdata(pedido);
      }
    },
    [setSessionMessage],
  );

  useEffect(() => {
    getPedidosCatalogo();
  }, [getPedidosCatalogo]);

  return (
    <div id={styles.digitalOrders} className={`${styles[screenSize]}`}>
      <Alert open={open} setOpen={setOpen} title={t('alertTitle')} text={alertText} />
      <SectionTitle title={t('title')} subtitle={t('subtitle')} />
      <div className={styles.dateContainer}>
        <div className={styles.inputcontainer}>
          <TextInput
            type='month'
            value={ordersDate}
            onChange={setOrdersDate}
            name='productID'
            placeholder={t('keyPlaceholder')}
          />
        </div>
        <div className={styles.button} onClick={() => searchByDate()}>
          {t('show')}
        </div>
      </div>
      <OrderCard>
        <div className={styles.table}>
          {tableItems.map((value, key) => {
            return (
              <div className={styles.text} key={key}>
                {t(value.title)}
              </div>
            );
          })}
        </div>
        {data.map((order, key) => {
          return (
            <ItemOrder
              screenSize={screenSize}
              getPedidosCatalogo={getPedidosCatalogo}
              setSessionMessage={setSessionMessage}
              order={order}
              key={key}
            />
          );
        })}
      </OrderCard>
    </div>
  );
}
